import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Instruments } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useUpdateInstrumentMutation = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: Instruments.UpdateInstrumentParams) =>
      api.instruments.updateInstrument(body),
    onSuccess(_data, variables) {
      toast.success(
        `Successfully updated ${variables.updatedField} from ${variables.oldValue} to ${variables.newValue}`,
      )
    },
    onError(error, variables) {
      toastApiError(
        error,
        `Error updating ${variables.updatedField} from ${variables.oldValue} to ${variables.newValue}`,
      )
    },
    onSettled() {
      queryClient.invalidateQueries({ queryKey: ['instruments'] })
    },
  })
}
export const useUpdateBasketoptionMutation = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: Instruments.UpdateInstrumentParams) =>
      api.instruments.updateBasketoption(body),
    onSuccess(_data, variables) {
      toast.success(
        `Successfully updated ${variables.updatedField} from ${variables.oldValue} to ${variables.newValue}`,
      )
    },
    onError(error, variables) {
      toastApiError(
        error,
        `Error updating ${variables.updatedField} from ${variables.oldValue} to ${variables.newValue}`,
      )
    },
    onSettled() {
      queryClient.invalidateQueries({ queryKey: ['basketoptions'] })
    },
  })
}
export const useUpdateMarketdataInstrumentMutation = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: Instruments.UpdateInstrumentParams) =>
      api.instruments.updateMarketdataInstrument(body),
    onSuccess(_data, variables) {
      toast.success(
        `Successfully updated ${variables.updatedField} from ${variables.oldValue} to ${variables.newValue}`,
      )
    },
    onError(error, variables) {
      toastApiError(
        error,
        `Error updating ${variables.updatedField} from ${variables.oldValue} to ${variables.newValue}`,
      )
    },
    onSettled() {
      queryClient.invalidateQueries({ queryKey: ['marketdata-instruments'] })
    },
  })
}

export const useCreateInstrumentMutation = () => {
  const queryClient = useQueryClient()

  const api = useApi()

  return useMutation({
    mutationFn: (params: Parameters<typeof api.instruments.create>[0]) => {
      return api.instruments.create(params)
    },
    onSuccess: (_data) => {
      const data = _data
      const identifier = data?.[0].unique_identifier
      toast.success(`Successfully created instrument ${identifier}`)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['instruments'] })
      queryClient.invalidateQueries({ queryKey: ['basketoptions'] })
      queryClient.invalidateQueries({ queryKey: ['marketdata-instruments'] })
      queryClient.invalidateQueries({ queryKey: ['vanillaoptions'] })
      queryClient.invalidateQueries({ queryKey: ['barrieroptions'] })
    },
  })
}
